import { Button } from "@material-ui/core";
import { useMemo } from "react";
import { useUserContext } from "src/context/config/userContext";
import { useProviderSelector } from "src/ether-utils/context/providerContext";
import SignerMessage from "src/ether-utils/signer-message";
import useNotify from "src/hooks/useNotify";
import { monitoringClient } from "src/services/requestClient";
import { getNonce } from "src/services/utils";
import { useWeb3Connect } from "src/wallet-connection/context/we3-connect-context";

export default function AuthorizationButton({ text = "Authorize", ...props }) {
  const { signer } = useProviderSelector((state) => state.wallet);
  const { address } = useWeb3Connect();
  const { setUserConfig } = useUserContext();
  const { errorNotify } = useNotify();

  const signMessage = useMemo(() => {
    if (signer) return new SignerMessage(signer);
    return null;
  }, [signer]);

  const onSignMessageClick = async () => {
    if (signMessage) {
      try {
        const nonce = getNonce();
        const result = await signMessage.signMessage(`I am signing my one-time nonce: ${nonce}`);
        if (!result.error) {
          const jwtData = await monitoringClient.post("/auth/login", {
            nonce: nonce,
            signature: result.signature,
            address: address,
          });
          if (jwtData?.success) setUserConfig(jwtData.jwt, address, jwtData.role);
          else errorNotify(jwtData.error);
        } else errorNotify(result.error?.message);
      } catch (error) {
        errorNotify(error.toString());
      }
    }
    if (props?.onClick) props.onClick();
  };

  return (
    <Button {...props} onClick={() => onSignMessageClick()}>
      {text}
    </Button>
  );
}
